var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-assign",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.259,
    height: 27.191,
    viewBox: "0 0 29.259 27.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 3.338,
    height: 1.269,
    transform: "translate(2.744 17.82)",
    fill: "#696969"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 3.338,
    height: 1.269,
    transform: "translate(2.744 4.112)",
    fill: "#696969"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 3.338,
    height: 1.269,
    transform: "translate(10.359 17.82)",
    fill: "#696969"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 3.338,
    height: 1.269,
    transform: "translate(10.359 8.553)",
    fill: "#696969"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 3.338,
    height: 1.269,
    transform: "translate(17.973 4.112)",
    fill: "#696969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M27.941,20.178V7.8a.635.635,0,0,0-.635-.635H19.753a.635.635,0,0,0-.635.635v3.807H12.713V7.8a.635.635,0,0,0-.635-.635H4.525A.635.635,0,0,0,3.89,7.8V29.749a.635.635,0,0,0,.635.635H19.452a7.237,7.237,0,1,0,8.49-10.206Zm-16.5,8.94H5.159V8.426h6.285Zm7.675-4.5a7.221,7.221,0,0,0-.165,4.5H12.713V12.868h6.405Zm1.269-16.18h6.285V19.924a7.221,7.221,0,0,0-6.285,2.538ZM25.911,33.09a5.968,5.968,0,1,1,5.968-5.968A5.968,5.968,0,0,1,25.911,33.09Z",
    transform: "translate(-3.89 -7.17)",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M63.541,65.464l-2.183-2.183-.9.9,3.081,3.081,4.835-4.832-.9-.9Z",
    transform: "translate(-42.513 -44.284)",
    fill: "#696969"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignIcon);
export default __webpack_public_path__ + "static/media/assignIcon.2ddf5f8fd27ee6922a5043da7fc01df3.svg";
export { ForwardRef as ReactComponent };